"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBlank = void 0;
function isBlank(value) {
    return !value || value.trim() === '';
}
exports.isBlank = isBlank;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNCbGFuay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9pc0JsYW5rLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLFNBQWdCLE9BQU8sQ0FBQyxLQUFnQztJQUN0RCxPQUFPLENBQUMsS0FBSyxJQUFJLEtBQUssQ0FBQyxJQUFJLEVBQUUsS0FBSyxFQUFFLENBQUM7QUFDdkMsQ0FBQztBQUZELDBCQUVDIn0=